/* const RecaudosEx = [
    {
        id: 0,
        recaudo: "Dos (2) fotografías de frente tamaño carnet, recientes e iguales a color (no instantáneas)."
    },
    {
        id: 1,
        recaudo: "Original y fotocopia en fondo negro de las Notas Certificadas de Bachiller. Este documento debe estar apostillado por el ente correspondiente en el país donde cursaste y aprobaste tus estudios de bachillerato y en caso de ser necesario, debidamente traducido al castellano."
    },
    {
        id: 2,
        recaudo: "Original y fotocopia en fondo negro (en papel fotográfico) del Título de Bachiller. Este documento debe estar apostillado por el ente correspondiente en el país donde cursaste y aprobaste tus estudios de bachillerato y en caso de ser necesario, debidamente traducido al castellano."
    },
    {
        id: 3,
        recaudo: "Fotocopia ampliada de la Cédula de Identidad de extranjero. Los estudiantes extranjeros que no posean Cédula de Identidad deben entregar obligatoriamente la fotocopia ampliada del pasaporte con su condición legal en el país, (residente o visa estudiantil). De igual manera, deben consignar copia del Certificado de Participación a la Educación Universitaria (C.N.U) o el Sistema Nacional de Ingreso (SNI); y los demás recaudos anteriormente señalados, a excepción de la copia del Registro Militar Obligatorio."
    },
    {
        id: 4,
        recaudo: "Original y fotocopia de la Partida de Nacimiento legible, sin tachaduras ni enmiendas."
    }
]
 */

const RecaudosEx = [
    {
        id: 0,
        recaudo: "Dos (2) fotografías de frente, tamaño carnet, recientes e iguales, a color (no instantáneas)."
    },
    {
        id: 1,
        recaudo: "Original y fotocopia en fondo negro de las Notas Certificadas de Bachiller. Este documento debe estar apostillado por el ente correspondiente en el país donde cursó y aprobó estudios de bachillerato y, en caso de ser necesario, debidamente traducido al castellano."
    },
    {
        id: 2,
        recaudo: "Original y fotocopia en fondo negro (en papel fotográfico) del Título de Bachiller. Este documento debe estar apostillado por el ente correspondiente en el país donde cursó y aprobó los estudios de bachillerato y, en caso de ser necesario, debidamente traducido al castellano."
    },
    {
        id: 3,
        recaudo: "Fotocopia ampliada de la Cédula de Identidad de extranjero. Los estudiantes extranjeros que no posean Cédula de Identidad deben entregar obligatoriamente la fotocopia ampliada del pasaporte, con su condición legal en el país, (residente o visa estudiantil)."
    },
    {
        id: 4,
        recaudo: "Copia de la Partida de Nacimiento legible, sin tachaduras ni enmiendas."
    },
    {
        id: 5,
        recaudo: "Visa respectiva, emitida por los organismos oficiales de la República Bolivariana de Venezuela."
    },
    {
        id: 6,
        recaudo: "Copia del comprobante de preinscripción nacional, y copia de la constancia de presentación de la Prueba Nacional de Aptitud Académica (CNU) o del Registro Nacional de Ingreso (RUSNIEU) y los demás recaudos anteriormente señalados, a excepción de la copia del Registro Militar Obligatorio."
    }
]

export default RecaudosEx;


// WEBPACK FOOTER //
// ./src/shared/RecaudosEx.jsx